import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=d9d2144c&scoped=true&"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=d9d2144c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d2144c",
  null
  
)

export default component.exports